/**
 * Sentry — opt-in via REACT_APP_SENTRY_DSN env var.
 * If not set, no-op (zero overhead, no network calls).
 *
 * Loaded synchronously from index.js BEFORE React renders so SSR-like
 * error capture starts as early as possible. Tree-shaken when DSN is absent.
 */
import * as Sentry from '@sentry/react';

export function initSentry() {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) return; // disabled — most preview/local dev environments.

  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_LUMYN_ENV || 'preview',
    release: process.env.REACT_APP_GIT_SHA || undefined,
    // Conservative sampling — bump these in prod once we have a feel for volume.
    tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACES_RATE || 0),
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    // Don't ship PII; we own the backend audit log for forensics.
    sendDefaultPii: false,
  });

  if (typeof console !== 'undefined') {
    // Surface init success in dev so trainers running locally can see it.
    console.info('[Sentry] enabled for', process.env.REACT_APP_LUMYN_ENV || 'preview');
  }
}

export { Sentry };
